import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Fairfax County public safety news and updates" 
          className="hero-image" 
        />
        <p className="eyebrow">FCPD News</p>
        <h1>Stay Informed, Stay Safe</h1>
        <p className="lede">
          Independent local news coverage of public safety in Fairfax County. Here you will find reporting on
          crime prevention initiatives, community safety programs, and law enforcement activity affecting our
          neighborhoods.
        </p>
        <div className="cta-row">
          <a href="/updates" className="primary">
            Read the Latest Updates
          </a>
          <a href="/resources" className="secondary">
            Explore Crime Prevention Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Community Engagement</h2>
          <p>
            Coverage of how residents and local organizations are working toward a safer community through
            outreach programs and events.
          </p>
        </article>
        <article>
          <h2>Crime Prevention Tips</h2>
          <p>
            Practical resources and tips to help protect yourself and your property from crime.
          </p>
        </article>
        <article>
          <h2>Law Enforcement Initiatives</h2>
          <p>
            Reporting on public safety initiatives and efforts to build trust within the community.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;
